/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 2019-06-28
 * Copyright All Rights Reserved
 */
// @flow
import * as React from 'react';
import { NavLink as Link } from 'react-router-dom';
import { NavLink } from 'reactstrap';
import { active, link } from './index.module.scss';

type Props = {
  children: React.Node,
  disabled?: boolean,
  to: string,
}
const SidebarNavLink = ({
  disabled,
  to,
  children,
}: Props) => (
  disabled
    ? (
      <NavLink className="disabled" tag="span">
        {children}
      </NavLink>
    )
    : (
      <NavLink to={to} activeClassName={active} tag={Link} className={link}>
        {children}
      </NavLink>
    )
);

SidebarNavLink.defaultProps = {
  disabled: false,
};

export default SidebarNavLink;



// WEBPACK FOOTER //
// ./js/components/support/layout/Sidebar/SidebarNavLink/index.jsx